import React from 'react'
import { connect } from 'react-redux'
import { CompactPicker } from 'react-color'
import { editSets } from "../../actions/settings"
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsFiletypeItem extends SettingsItemForm {

  modelName = 'filetype'

  selectColor = () => {
    this.setState({colorPick: true});
  }

  applyColor = color => {
    this.setState({
      data: {
        ...this.state.data,
        filetype_color: color.hex
      },
      colorPick: false
    });
  }

  render() {
    const { data } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';
    const colorPick = this.state.colorPick ?
      <div style={{position:'absolute',zIndex:2,right:'15px'}}>
        <CompactPicker
          color={nData.filetype_color}
          onChangeComplete={ this.applyColor }
        />
      </div>
      :'';

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
          {colorPick}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.filetype_desc}
                name="filetype_desc"
                onChange={this.updateInput}
                placeholder="Название"
                autoFocus
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td
            style={{
              backgroundColor: nData.filetype_color,
              cursor: 'pointer'
            }}
            onClick={this.selectColor}
          >
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.filetype_desc}</td>
          <td style={{backgroundColor: data.filetype_color}}></td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsFiletypeItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsFiletypeItem.js